import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoneyDollar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 1H1v2h10zm3 4v1h1.56v2h-3.13a.406.406 0 0 0-.408.404c0 .185.127.347.31.392l1.893.468c2.48.614 2.307 4.279-.225 4.702V15h-2v-1h-1.495v-2h3.13c.226 0 .409-.18.409-.404a.405.405 0 0 0-.31-.392l-1.893-.468A2.41 2.41 0 0 1 10 8.404c0-1.19.852-2.178 2-2.37V5zM1 13h6v2H1zm6-4H1v2h6zM1 5h6v2H1z"
	})
});
export default SvgMoneyDollar;
